module.exports = __webpack_public_path__ + "static/media/faithmo_blue_logo.9aa655f6.png";